define('modules/editor/models/property_groups/form_geometry',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "form:geometry",
    properties: ["top", "left", "width", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight", "position"],
    defaults: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      position: "absolute"
    },
    generateStyles: function($el, id){
      return [{
        selector: "#" + id,
        rules: {
          "top": this.get("top") + "px",
          "left": this.get("left") + "px",
          "width": this.get("width") + "px",
          "padding-top": this.get("paddingTop") + "px",
          "padding-bottom": this.get("paddingBottom") + "px",
          "padding-left": this.get("paddingLeft") + "px",
          "padding-right": this.get("paddingRight") + "px"
        }
      }];
    },
    /*applyStyles: function($el) {
      $el.toggleClass('fixed-form', this.get('fixed'));
    },*/
    validators: {
      "top": function(attrs){
        var value = parseInt(attrs.top);
        return this.isInteger(attrs.top) && this.isNumber(value) && this.isInRange(value, 0, 2000);
      },
      left: function(attrs){
        var value = parseInt(attrs.left);
        return this.isInteger(attrs.left) && this.isNumber(value) && this.isInRange(value, 0, 2000);
      },
      width: function(attrs){
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isNumber(value) && this.isInRange(value, 10, 2000);
      },
      paddingTop: function(attrs){
        var value = parseInt(attrs.paddingTop);
        return this.isInteger(attrs.paddingTop) && this.isNumber(value) && this.isInRange(value, 0, 100);
      },
      paddingBottom: function(attrs){
        var value = parseInt(attrs.paddingBottom);
        return this.isInteger(attrs.paddingBottom) && this.isNumber(value) && this.isInRange(value, 0, 100);
      },
      paddingLeft: function(attrs){
        var value = parseInt(attrs.paddingLeft);
        return this.isInteger(attrs.paddingLeft) && this.isNumber(value) && this.isInRange(value, 0, 100);
      },
      paddingRight: function(attrs){
        var value = parseInt(attrs.paddingRight);
        return this.isInteger(attrs.paddingRight) && this.isNumber(value) && this.isInRange(value, 0, 100);
      }
    }
  });

  //util.mixin(module.exports, require("../../behaviours/apply_css_properties"));

});

